import React from 'react';
import { Modal } from 'antd';
import { useFormContext } from 'react-hook-form';
import { AlertSuccess } from '../../../../util/Alert';
import { useQueryClient } from '@tanstack/react-query';
import fitSurvey2Services from '../../../../../services/fit-survey2.services';
import LegacySurveyPartForm from '../form/LegacySurveyPartForm';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const LegacySurveyPartModal = ({ open, handleClose }) => {
  const { watch, handleSubmit } = useFormContext();
  const queryClient = useQueryClient();
  const params = useParams();

  const { mutate: createLegacySurveyPart } =
    fitSurvey2Services.useMutationCreateLegacySurveyPart(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-survey2-part'],
        refetchType: 'all',
      });
      AlertSuccess('เพิ่มข้อมูลสำเร็จ');
      handleClose();
    });

  const { mutate: editLegacySurveyPart } =
    fitSurvey2Services.useMutationUpdateLegacySurveyPart(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-survey2-part'],
        refetchType: 'all',
      });
      AlertSuccess('แก้ไขข้อมูลสำเร็จ');
      handleClose();
    });

  const _HandleSubmit = handleSubmit((data) => {
    const legaySurveyPartData = {
      title: data.title,
      surveyId: params.surveyId,
    };

    if (watch('formType') === 'create') {
      createLegacySurveyPart(legaySurveyPartData);
    } else if (watch('formType') === 'edit') {
      editLegacySurveyPart({ id: data.id, data: legaySurveyPartData });
    }
  });

  return (
    <Modal
      title={
        watch('formType') === 'create'
          ? 'เพิ่มแบบหัวข้อย่อย'
          : 'แก้ไขแบบหัวข้อย่อย'
      }
      visible={open}
      onCancel={handleClose}
      okText="บันทึก"
      cancelText="ยกเลิก"
      onOk={_HandleSubmit}
      width={'50vw'}
    >
      <LegacySurveyPartForm />
    </Modal>
  );
};

export default LegacySurveyPartModal;
